import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';
import { useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import { notificationService } from '../utils/notifications';
import env from '../config/env';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useSettings } from '../context/SettingsContext';
import { ShoppingCart, PlusCircle, Trash2 } from 'lucide-react';
import Select from 'react-select';

function Shitje() {
  const { lokacion_id, roli } = useAuth();
  const { theme } = useTheme();
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [produktet, setProduktet] = useState([]);
  const [lokacionet, setLokacionet] = useState([]);
  const [lokacionSelect, setLokacionSelect] = useState('');
  const [item, setItem] = useState({
    produkt_id: '',
    madhesi_id: '',
    ngjyra_id: '',
    sasia: 1,
    opsione: [],
    cmimi: 0,
    cmimi_origjinal: 0,
    zbritje: 0,
    foto: null
  });
  const [artikujt, setArtikujt] = useState([]);

  const getLokacionId = () => {
  if (roli === 'admin') return lokacionSelect;
  return lokacion_id;
};

// useEffect(() => {
//   console.log('Lokacion ID (nga useAuth):', lokacion_id);
//   console.log('Lokacion Select (nga admin):', lokacionSelect);
//   console.log('Roli:', roli);
//   console.log('getLokacionId:', getLokacionId());
// }, [lokacion_id, lokacionSelect, roli]);


useEffect(() => {
  const fetchProduktet = async () => {
    let lokId = null;

    if (roli === 'admin') {
      if (!lokacionSelect) return; // admini s'ka zgjedhur ende lokacionin
      lokId = lokacionSelect;
    } else {
      if (!lokacion_id) return; // menaxher/shites – ende nuk është marrë lokacion_id
      lokId = lokacion_id;
    }

    try {
      const produktet = await apiService.get('/produkte', {
        params: { lokacion_id: lokId }
      });
      // Handle pagination response format
      setProduktet(Array.isArray(produktet) ? produktet : (produktet?.data || []));
    } catch (error) {
      logger.error('Gabim gjatë ngarkimit të produkteve:', error);
    }
  };

  fetchProduktet();
}, [roli, lokacionSelect, lokacion_id]);




  useEffect(() => {
    const fetchLokacionet = async () => {
      if (roli === 'admin') {
        try {
          const lokacionet = await apiService.get('/lokacionet');
          setLokacionet(Array.isArray(lokacionet) ? lokacionet : (lokacionet?.data || []));
        } catch (error) {
          logger.error('Gabim gjatë ngarkimit të lokacioneve:', error);
        }
      }
    };
    fetchLokacionet();
  }, [roli]);

  const handleChange = async (field, value) => {
    const updated = { ...item, [field]: value };
  
    if (field === 'produkt_id') {
           if (!value) {
        updated.produkt_id = '';
        updated.opsione = [];
        updated.madhesi_id = '';
        updated.ngjyra_id = '';
        updated.cmimi = 0;
        updated.cmimi_origjinal = 0;
        updated.zbritje = 0;
        updated.foto = null;
        setItem(updated);
        return;
      }

      try {
        const produkt = await apiService.get(`/produkte/${value}/detaje-lokacion`, {
          params: { lokacion_id: getLokacionId() }
        });
        
        updated.opsione = produkt?.variacione?.filter(v => v.lokacion_id == getLokacionId() && v.sasia > 0) || [];
        updated.madhesi_id = '';
        updated.ngjyra_id = '';
        updated.cmimi = produkt?.cmimi_shitjes || 0;
        updated.cmimi_origjinal = produkt?.cmimi_shitjes || 0;
        updated.zbritje = produkt?.zbritje_perqindje || 0;

        if (updated.zbritje > 0) {
          updated.cmimi = +(updated.cmimi_origjinal - (updated.cmimi_origjinal * updated.zbritje / 100)).toFixed(2);
        }

        updated.foto = produkt?.foto?.[0]?.file_path || null;
      } catch (error) {
        logger.error("Gabim gjatë marrjes së produktit:", error);
        return;
      }
    }

    if (field === 'madhesi_id') {
      updated.ngjyra_id = '';
    }

    if (field === 'cmimi') {
      updated.cmimi = parseFloat(value) || 0;
    }

    setItem(updated);
  };

  const getMaxSasi = () => {
    const madhesiId = item.madhesi_id || null;
    const ngjyraId = item.ngjyra_id || null;
    const o = item.opsione.find(
      (x) =>
        (x.madhesi_id ?? null) === madhesiId &&
        (x.ngjyra_id ?? null) === ngjyraId &&
        Number(x.lokacion_id) === Number(getLokacionId())
    );
    return o?.sasia ?? 0;
  };

  const handleAdd = () => {
    if (!item.produkt_id || !item.sasia) return;

    const madhesiId = item.madhesi_id || null;
    const ngjyraId = item.ngjyra_id || null;

    const ekzistues = artikujt.find(x =>
      x.produkt_id === item.produkt_id &&
      (x.madhesi_id || null) === madhesiId &&
      (x.ngjyra_id || null) === ngjyraId
    );

    if (ekzistues) {
      ekzistues.sasia += parseInt(item.sasia, 10);
      setArtikujt([...artikujt]);
    } else {
      const madhesia = madhesiUnike.find(m => (m.id || null) === madhesiId)?.emri ?? '–';
      const ngjyra = ngjyraUnike.find(n => (n.id || null) === ngjyraId)?.emri ?? '–';

      setArtikujt([...artikujt, {
        ...item,
        madhesi_id: madhesiId,
        ngjyra_id: ngjyraId,
        madhesi_emri: madhesia,
        ngjyra_emri: ngjyra
      }]);
    }

    setItem({ produkt_id: '', madhesi_id: '', ngjyra_id: '', sasia: 1, opsione: [], cmimi: 0, foto: null });
  };

  const handleRemove = (index) => {
    const updated = [...artikujt];
    updated.splice(index, 1);
    setArtikujt(updated);
  };

  const totalGjithsej = artikujt.reduce((acc, a) => acc + (a.cmimi * a.sasia), 0);

  const { mutate: regjistroShitje, loading: savingShitje } = useMutation(
    async (data) => {
      const response = await apiService.post('/shitje', data);
      return response;
    },
    {
      successMessage: 'Shitja u regjistrua me sukses!',
      onSuccess: (response) => {
        setArtikujt([]);
        // window.open(response.pdf_url, '_blank'); // Uncomment nëse dëshiron PDF të hapet automatikisht
      }
    }
  );

  const handleSubmit = async () => {
    const lokId = getLokacionId();
    if (!lokId) {
      logger.error('Shitje: lokacioni nuk është zgjedhur');
      notificationService.error('Zgjidhni lokacionin për të regjistruar shitjen.');
      return;
    }

    const detajet = artikujt.map(a => ({
      produkt_id: a.produkt_id,
      madhesi_id: a.madhesi_id || null,
      ngjyra_id: a.ngjyra_id || null,
      sasia: parseInt(a.sasia, 10),
      cmimi: parseFloat(a.cmimi)
    }));

    try {
      await regjistroShitje({ detajet, lokacion_id: lokId });
    } catch (err) {
      logger.error('Gabim gjatë regjistrimit të shitjes:', err);
    }
  };

  const madhesiUnike = Array.from(
    new Map(
      item.opsione.map(o => [
        o.madhesi_id ?? 'n',
        { id: o.madhesi_id ?? null, emri: o.madhesia ?? 'Pa madhësi' }
      ])
    ).values()
  );

  const ngjyraUnike = Array.from(
    new Map(
      item.opsione
        .filter(o => (o.madhesi_id ?? null) === (item.madhesi_id || null))
        .map(o => [
          o.ngjyra_id ?? 'n',
          { id: o.ngjyra_id ?? null, emri: o.ngjyra ?? 'Pa ngjyre' }
        ])
    ).values()
  );


  // Custom styles for react-select based on theme
  const selectStyles = theme === 'dark' ? {
    control: (base, state) => ({
      ...base,
      backgroundColor: '#1e293b',
      borderColor: state.isFocused ? '#f59e0b' : '#475569',
      boxShadow: state.isFocused ? '0 0 0 1px #f59e0b' : 'none',
      '&:hover': { borderColor: '#f59e0b' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: '#1e293b',
      borderColor: '#475569',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#78350f' : state.isSelected ? '#f59e0b' : '#1e293b',
      color: state.isSelected ? 'white' : '#e2e8f0',
    }),
    singleValue: (base) => ({ ...base, color: '#e2e8f0' }),
    input: (base) => ({ ...base, color: '#e2e8f0' }),
    placeholder: (base) => ({ ...base, color: '#94a3b8' }),
  } : {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'transparent',
      borderColor: state.isFocused ? '#f59e0b' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 1px #f59e0b' : 'none',
      '&:hover': { borderColor: '#f59e0b' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: 'white',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#fef3c7' : state.isSelected ? '#fbbf24' : 'white',
      color: state.isSelected ? 'white' : '#111827',
    }),
  };

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <ShoppingCart size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Regjistro Shitje
      </h2>

      {roli === 'admin' && (
        <div className="card-premium p-4 mb-6 max-w-sm">
          <label className="form-label">Zgjidh Lokacionin</label>
          <Select
            options={lokacionet.map(l => ({ value: l.id, label: l.emri }))}
            value={lokacionet.find(l => l.id === lokacionSelect) ? { value: lokacionSelect, label: lokacionet.find(l => l.id === lokacionSelect)?.emri } : null}
            onChange={(option) => setLokacionSelect(option?.value ? parseInt(option.value) : '')}
            placeholder="Zgjidh lokacionin"
            className="w-full"
            isClearable
            styles={selectStyles}
            classNamePrefix="react-select"
          />
        </div>
      )}
      <div className="card-premium p-6 mb-6 grid grid-cols-1 md:grid-cols-7 gap-4 items-end">
        {/* <Select
  options={produktet
     .filter(p => p.eshte_aktiv != 2)
    .map(p => ({
    value: p.id,
    label: p.emri,
    image: p.foto?.[0]?.file_path ? `${env.API_URL_Image}/storage/${p.foto[0].file_path}` : null
  }))}
  value={
    item.produkt_id
      ? {
          value: item.produkt_id,
          label: produktet.find(p => p.id === parseInt(item.produkt_id))?.emri,
          image: produktet.find(p => p.id === parseInt(item.produkt_id))?.foto?.[0]?.file_path
            ? `${env.API_URL_Image}/storage/${produktet.find(p => p.id === parseInt(item.produkt_id)).foto[0].file_path}`
            : null
        }
      : null
  }
  onChange={(option) => handleChange('produkt_id', option?.value || '')}
  placeholder="Zgjidh produktin"
  className="w-full"
  isClearable
  formatOptionLabel={(option) => (
    <div className="flex items-center gap-2">
      {option.image && (
        <img src={option.image} alt={option.label} className="w-8 h-8 object-cover rounded" />
      )}
      <span>{option.label}</span>
    </div>
  )}
/> */}

<Select
  options={produktet
    .filter(p => p.eshte_aktiv != 2)
    .map(p => ({
      value: p.id,
      label: `${p.kodi || ''} - ${p.emri}`,
      image: p.foto?.[0]?.file_path ? `${env.API_URL_Image}/storage/${p.foto[0].file_path}` : null
    }))}
  value={
    item.produkt_id
      ? {
          value: item.produkt_id,
          label: `${produktet.find(p => p.id === parseInt(item.produkt_id))?.kodi || ''} - ${produktet.find(p => p.id === parseInt(item.produkt_id))?.emri}`,
          image: produktet.find(p => p.id === parseInt(item.produkt_id))?.foto?.[0]?.file_path
            ? `${env.API_URL_Image}/storage/${produktet.find(p => p.id === parseInt(item.produkt_id)).foto[0].file_path}`
            : null
        }
      : null
  }
  onChange={(option) => handleChange('produkt_id', option?.value || '')}
  placeholder="Zgjidh produktin"
  className="w-full"
  isClearable
  styles={selectStyles}
  classNamePrefix="react-select"
  formatOptionLabel={(option) => (
    <div className="flex items-center gap-2">
      {option.image && (
        <img src={option.image} alt={option.label} className="w-8 h-8 object-cover rounded" />
      )}
      <span>{option.label}</span>
    </div>
  )}
  filterOption={(option, inputValue) =>
    option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
/>

 
 <Select
  options={madhesiUnike.map((m) => ({ value: m.id, label: m.emri }))}
  //value={item.madhesi_id ? { value: item.madhesi_id, label: madhesiUnike.find(m => m.id === parseInt(item.madhesi_id))?.emri} : null}
 value={madhesiUnike
  .map(m => ({ value: m.id ?? '', label: m.emri }))
  .find(option => (option.value ?? '') === (item.madhesi_id ?? '')) || null}

  onChange={(option) => handleChange('madhesi_id', option?.value ?? '')}
  placeholder="Zgjidh madhësinë"
  className="w-full"
  isClearable
  styles={selectStyles}
  classNamePrefix="react-select"
  formatOptionLabel={(option) => (
    <div className="flex items-center gap-2">
      <span>{option.label}</span>
    </div>
  )}
/>

       <Select
  options={ngjyraUnike.map((n) => ({ value: n.id, label: n.emri }))}
  //value={item.ngjyra_id ? { value: item.ngjyra_id, label: ngjyraUnike.find(n => n.id === parseInt(item.ngjyra_id))?.emri } : null}
 value={ngjyraUnike
  .map(n => ({ value: n.id ?? '', label: n.emri }))
  .find(option => (option.value ?? '') === (item.ngjyra_id ?? '')) || null}

  onChange={(option) => handleChange('ngjyra_id', option?.value ?? '')}
  placeholder="Zgjidh ngjyrën"
  className="w-full"
  isClearable
  styles={selectStyles}
  classNamePrefix="react-select"
  formatOptionLabel={(option) => (
    <div className="flex items-center gap-2">
      <span>{option.label}</span>
    </div>
  )}
/>

        <div>
          <input 
            type="number" 
            min="1" 
            max={getMaxSasi()} 
            value={item.sasia} 
            onChange={(e) => handleChange('sasia', e.target.value)} 
            className="input-premium" 
          />
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Max: {getMaxSasi()}</div>
        </div>
        {/* <div className="text-sm font-semibold">{item.cmimi} x {item.sasia} = <span className="text-indigo-600">{item.cmimi * item.sasia} DEN</span></div>
  */}

{/* <div className="flex flex-col items-end gap-1 text-right">
  <div className="flex items-center gap-2">
    <span className="text-sm text-gray-600">Çmimi:</span>
    <input
      type="number"
      step="1"
      className="w-24 px-2 py-1 border border-gray-300 rounded-md text-right shadow-sm"
      value={item.cmimi}
      onChange={(e) => handleChange('cmimi', parseFloat(e.target.value))}
    />
  </div>
  <div className="text-sm text-gray-600">
    x {item.sasia} = <span className="font-bold text-primary-600 dark:text-primary-400">{(item.cmimi * item.sasia).toFixed(2)} DEN</span>
  </div>
</div> */}

<div className="flex flex-col items-end gap-1 text-right">
  <div className="flex items-center gap-2">
    <span className="text-sm text-gray-600 dark:text-gray-400">Çmimi:</span>
    <input
      type="number"
      step="1"
      className="w-24 px-2 py-1.5 input-premium text-right"
      value={Number(item.cmimi || 0).toFixed(2)}
      onChange={(e) => handleChange('cmimi', parseFloat(e.target.value))}
    />
  </div>

  {item.zbritje > 0 && (
    <div className="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-2">
      <span className="line-through text-red-600 dark:text-red-400">{item.cmimi_origjinal} {currencyCode}</span>
      <span className="text-green-700 dark:text-green-400 font-semibold">-{item.zbritje}%</span>
    </div>
  )}

  <div className="text-sm text-gray-600 dark:text-gray-400">
    x {item.sasia} = <span className="font-bold text-gradient-logo">{(item.cmimi * item.sasia).toFixed(2)} {currencyCode}</span>
  </div>
</div>




        <button 
          onClick={handleAdd} 
          className="btn-premium-secondary-gradient flex items-center justify-center gap-2 w-full text-sm"
        >
          <PlusCircle size={16} /> Shto
        </button>
      </div>

      {artikujt.length > 0 && (
        <>
          <div className="flex justify-end mb-6">
            <button 
              onClick={handleSubmit} 
              disabled={savingShitje}
              className="btn-primary text-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {savingShitje ? 'Po regjistrohet...' : 'Regjistro dhe Printo Kuponin'}
            </button>
          </div>

          <div className="hidden md:block overflow-x-auto card-premium">
            <table className="table-premium">
              <thead>
                <tr>
                  <th>Foto</th>
                  <th>Produkti</th>
                  <th>Madhësia</th>
                  <th>Ngjyra</th>
                  <th>Çmimi</th>
                  <th>Sasia</th>
                  <th>Total</th>
                  <th>Fshi</th>
                </tr>
              </thead>
              <tbody>
                {artikujt.map((a, idx) => (
                  <tr key={idx}>
                    <td>
                      {a.foto && <img src={`${env.API_URL_Image}/storage/${a.foto}`} alt="" className="w-12 h-12 object-cover rounded-lg" />}
                    </td>
                    <td className="font-medium">{produktet.find(p => p.id === parseInt(a.produkt_id))?.emri}</td>
                    <td>{a.madhesi_emri}</td>
                    <td>{a.ngjyra_emri}</td>
                    <td>{a.cmimi} {currencyCode}</td>
                    <td>{a.sasia}</td>
                    <td className="font-semibold text-primary-600 dark:text-primary-400">{a.cmimi * a.sasia} {currencyCode}</td>
                    <td>
                      <button onClick={() => handleRemove(idx)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 transition-colors">
                        <Trash2 size={18} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
                {/* View për mobile – karta për çdo produkt të shtuar në shitje */}
<div className="block md:hidden space-y-4 mt-4">
  {artikujt.map((s, idx) => (
    <div
      key={`${s.produkt_id}-${s.madhesi_id}-${s.ngjyra_id}`}
      className="card-premium p-4 relative"
    >
      <button
        onClick={() => handleRemove(idx)}
        className="absolute top-3 right-3 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 transition-colors"
      >
        <Trash2 size={18} />
      </button>

      <div className="flex items-center gap-3 mb-3 pr-8">
        {s.foto && (
          <img
            src={`${env.API_URL_Image}/storage/${s.foto}`}
            alt=""
            className="w-16 h-16 object-cover rounded-lg"
          />
        )}
        <div>
          <p className="font-semibold text-gray-900 dark:text-gray-100">
            {produktet.find(p => p.id === parseInt(s.produkt_id))?.emri}
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Madhësia: {s.madhesi_emri} • Ngjyra: {s.ngjyra_emri}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 text-sm text-gray-700 dark:text-gray-300">
        <div>
          <strong>Çmimi:</strong> {s.cmimi} {currencyCode}
        </div>
        <div>
          <strong>Sasia:</strong> {s.sasia}
        </div>
        <div className="col-span-2 font-semibold text-right text-gradient-logo">
          Total: {(s.cmimi * s.sasia).toFixed(2)} {currencyCode}
        </div>
      </div>
    </div>
  ))}
</div>

          <div className="card-premium p-6 mt-6">
            <div className="text-right text-2xl font-bold text-gradient-logo">
              Totali: {totalGjithsej} {currencyCode}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Shitje;
